import { request } from "./client";
import USE_MOCK from "../mock/config";
import {
  mockFetchTenants, mockFetchTenant, mockCreateTenant,
  mockUpdateTenant, mockUpdateTenantStatus, mockDeleteTenant,
} from "../mock/mockHandlers";

const TENANT_BASE = "/bots";

export const fetchTenants = (params = {}) =>
  USE_MOCK ? mockFetchTenants(params) : request(TENANT_BASE, { params });
export const fetchTenant = (tenantId) =>
  USE_MOCK ? mockFetchTenant(tenantId) : request(`${TENANT_BASE}/${tenantId}`);
export const createTenant = async (payload) => {
  // console.log("[TenantCreate] request", {
  //   method: "POST",
  //   endpoint: TENANT_BASE,
  //   payload,
  // });

  try {
    const response = USE_MOCK
      ? await mockCreateTenant(payload)
      : await request(`${TENANT_BASE}/`, { method: "POST", data: payload });
    // console.log("[TenantCreate] response", response);
    return response;
  } catch (error) {
    // console.error("[TenantCreate] error", {
    //   status: error?.status,
    //   message: error?.message,
    //   details: error?.details,
    // });
    throw error;
  }
};
export const updateTenant = (tenantId, payload) =>
  USE_MOCK ? mockUpdateTenant(tenantId, payload) : request(`${TENANT_BASE}/${tenantId}`, { method: "PUT", data: payload });
export const updateTenantStatus = (tenantId, payload) =>
  USE_MOCK ? mockUpdateTenantStatus(tenantId, payload) : request(`${TENANT_BASE}/${tenantId}/status`, { method: "PUT", data: payload });
export const deleteTenant = (tenantId) =>
  USE_MOCK ? mockDeleteTenant(tenantId) : request(`${TENANT_BASE}/${tenantId}`, { method: "DELETE" });
